export default __webpack_public_path__ + "static/media/trabuc-night.e315c7bf.jpg";